import {sxhr} from 'fire-wind-water/sxhr';
export class WxData {
  constructor() {
  }
  createPromose(){
    let success = null;
    let error = null;
    let pomo = new Promise((resolve, reject) => {
      success = resolve;
      error = reject;
    });
    return {
      promise: pomo,
      resolve: success,
      reject: error
    };
  }
  getWxJssdkConfig(info, url){
    let porm = this.createPromose();
    sxhr.post(`${url}/api/wechat/jssdk/config/get`, info).then(data => {
      if(data.status == 200){
        porm.resolve(data.data.body);
      }else{
        porm.reject(data);
      }
    }, err => {
      porm.reject(err);
    });
    return porm.promise;
  }
  getDefaultWxJssdkConfig(info,url){
    let porm = this.createPromose();
    sxhr.post(`${url}/article/share`, info).then(data => {
      if(data.status == 200){
        porm.resolve(data.data.body);
      }else{
        porm.reject(data);
      }
    }, err => {
      porm.reject(err);
    });
    return porm.promise;
  }
}